import { MapViewer } from '../MapViewer/MapViewer';

import type { Layer } from 'sonata-static-storage/lib/common/common.types';
import type { LayerMapData } from 'sonata-static-storage/lib/common/itemsGrouping.types';
import type { PublicLayerDTO, PublicMapDataPointDTO } from '../sharedMap.types';

type Props = {
  layer: PublicLayerDTO;
  mapData: PublicMapDataPointDTO[];
  style?: 'dark' | 'light';
};

export function LayerMapView({ layer, mapData, style }: Props): JSX.Element {
  return (
    <MapViewer layer={layer as unknown as Layer} layerMapData={mapData as unknown as LayerMapData[]} style={style} />
  );
}
